<template>
  <div class="w-100" :id="id">
    <div v-if="type == 'media_and_if'" class="flex-row w-100">
      <div class="new-report-media-profile pointer">
        <div class="data-table-th-picture report pointer">
          <img :src="value.profile_picture_url" alt class="report-media-profile-img" @error="imgError()"  @click="openMedia(index)"/>
          <favorite :favorite="value.favorite" :index="index" :referer="'report'" />
          <!-- <stories :ig_id="value.ig_id" :stories="value.stories" :index="index" :referer="'report'" @storiesReactive="storiesReactive"/> -->
        </div>
        <div class="report-media-profile-namearea" @click="openMedia(index)">
          <div class="report-media-profile-accountname">{{ value.account_name }}<img src="../../assets/badge.png" style="width: 14px; height: 14px" v-show="value.badge" /></div>
          <div class="report-media-profile-name">{{ value.name }}</div>
        </div>
      </div>
    </div>
    <div v-else-if="type == 'number' || type == 'cost_setting'">
      <span v-if="value">{{ value | addComma }}</span>
      <el-tooltip placement="top" content="投稿一覧で編集可能です" v-else>
        <span><font-awesome-icon :icon="['far', 'hourglass-half']" style="color: #ccc"/></span>
      </el-tooltip>
    </div>
    <div v-else-if="type == 'percent'">
      <span v-if="value">{{ value + "%" }}</span>
      <el-tooltip placement="top" content="投稿一覧で指標を編集することで自動算出されます" v-else>
        <span><font-awesome-icon :icon="['far', 'hourglass-half']" style="color: #ccc"/></span>
      </el-tooltip>
    </div>
    <div v-else-if="type == 'cost' || type == 'cost_setting'">
      <span v-if="value">¥{{ value }}</span>
      <el-tooltip placement="top" content="投稿一覧でコストを設定することで自動算出されます" v-else>
        <span><font-awesome-icon :icon="['far', 'hourglass-half']" style="color: #ccc"/></span>
      </el-tooltip>
    </div>
    <div v-else-if="type == 'refer'">
      <span v-if="value">{{ value | addComma }}</span>
      <el-tooltip placement="top" content="該当のデータが存在するインフルエンサーのみ表示されます" v-else>
        <span><font-awesome-icon :icon="['far', 'hourglass-half']" style="color: #ccc"/></span>
      </el-tooltip>
    </div>
    <div v-else-if="type == 'refer_percent'">
      <span v-if="value">{{ value + "%" }}</span>
      <el-tooltip placement="top" content="該当のデータが存在するインフルエンサーのみ表示されます" v-else>
        <span><font-awesome-icon :icon="['far', 'hourglass-half']" style="color: #ccc"/></span>
      </el-tooltip>
    </div>
    <genderRatio v-else-if="type == 'gender_ratio'" :female_ratio="value.female_ratio" :male_ratio="value.male_ratio" />
    <div v-else>
      <span v-if="value">{{ value }}</span>
    </div>
  </div>
</template>

<script>
const root = process.env.VUE_APP_API;
const changeReportPostAPI = root + "/api/report/change_report_post";

import genderRatio from "../list/gender_ratio";
import favorite from "../list/favorite";
// import stories from "../influencer/stories.vue"

export default {
  name: "reportInfluencerValue",
  props: ["report_id", "ig_id", "column", "index", "id", "value", "type"],
  components: {
    genderRatio,
    favorite,
    // stories
  },
  data() {
    return {
      open: false,
      editing: false,
      edit_value: "",
      s3BaseUrl: process.env.VUE_APP_S3_BASE_URL,
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
  },
  mounted() {},
  methods: {
    openCell(value) {
      this.open = true;
      if (value) {
        this.edit_value = value;
      } else {
        this.edit_value = this.value;
      }
      setTimeout(() => {
        document.getElementById("input-" + this.id).focus();
        this.addKeyDown();
      }, 50);
    },
    editValue(presskey) {
      this.open = false;
      this.editing = true;
      if (this.value != this.edit_value) {
        var params = new URLSearchParams();
        params.append("token", this.token);
        params.append("report_id", this.report_id);
        params.append("media_id", this.media_id);
        params.append("column", this.column);
        params.append("value", this.edit_value);
        this.axios
          .post(changeReportPostAPI, params)
          .then((response) => {
            this.$emit("updateValue", this.index, response.data.new_post_data);
          })
          .catch(() => {});
      }
      this.removeKeyDown();
      this.$emit("finishEdit", presskey);
      setTimeout(() => {
        this.editing = false; //keypressEnter/blur/changeが同時に発動しないように
      }, 300);
    },
    imgError() {
      this.value.profile_picture_url = this.s3BaseUrl + "/userdata/img_error.png";
    },
    openMedia() {
      this.$emit("openMedia", this.index);
    },
    addKeyDown() {
      document.addEventListener("keydown", this.onKeyDown);
    },
    removeKeyDown() {
      document.removeEventListener("keydown", this.onKeyDown);
    },
    onKeyDown(event) {
      if (event.key == "ArrowUp") event.preventDefault();
      if (event.key == "ArrowDown") event.preventDefault();
    },
    storiesReactive(){
      this.$emit("storiesReactive", this.index);
    }
  },
  beforeDestroy() {
    this.removeKeyDown();
  },
  watch: {},
  filters: {
    addComma(val) {
      if (isNaN(val)) {
        return val;
      } else {
        return Math.floor(val).toLocaleString();
      }
    },
  },
};
</script>
